import React from 'react';
import PropTypes from 'prop-types';
import AnalyticsDateRangePicker from './AnalyticsDateRangePicker';
import AnalyticsReportExportButton from './AnalyticsReportExportButton';
import styles from './AnalyticsReportActions.module.scss';

export default function AnalyticsReportActions({
  exportEnabled,
  shopId,
  reportType,
  timeframe,
  onSubmitRange,
  isFetching,
  localizeMessage,
}) {
  return (
    <div className={styles.actions}>
      {exportEnabled && (
        <AnalyticsReportExportButton
          disabled={isFetching}
          reportType={reportType}
          shopId={shopId}
        />
      )}
      <AnalyticsDateRangePicker
        timeframe={timeframe}
        onSubmitRange={onSubmitRange}
        isFetching={isFetching}
        localizeMessage={localizeMessage}
      />
    </div>
  );
}

AnalyticsReportActions.propTypes = {
  exportEnabled: PropTypes.bool,
  shopId: PropTypes.string,
  reportType: PropTypes.oneOf(['top_queries', 'zero_results', 'lost_opportunities']).isRequired,
  timeframe: PropTypes.shape({ from: PropTypes.any, to: PropTypes.any }),
  onSubmitRange: PropTypes.func,
  isFetching: PropTypes.bool,
  localizeMessage: PropTypes.func,
};

AnalyticsReportActions.defaultProps = {
  exportEnabled: false,
  shopId: null,
  timeframe: null,
  onSubmitRange: null,
  isFetching: false,
  localizeMessage: null,
};
